import { NodeProps } from 'reactflow';

import { Icon, RyeconEyeClosed, RyeconKey } from '@dbt-labs/sourdough';

import { InteractionDagNode } from '../../dag/internalDag';
import { DbtDagNode } from '../../dbt-dag';
import { getReleaseVersionText } from './types';
import { smartSplitString } from './utils';

export const MainLabel = <TDbtDagNode extends DbtDagNode>({
  data,
}: NodeProps<InteractionDagNode<TDbtDagNode>>) => {
  const { label, releaseVersion, labelIcon } = data;

  const { firstPart, secondPart } = smartSplitString(label);

  return (
    <div className="flex items-center text-base">
      {labelIcon === 'noAccess' && (
        <>
          <Icon size="xs" className="ml-1 mr-2" ryecon={RyeconEyeClosed} />
        </>
      )}
      <span className="line-clamp-2 whitespace-normal">
        {secondPart ? `${firstPart} ${secondPart}` : firstPart}
      </span>

      {releaseVersion && (
        <span className={'text-fgDecorative'}>
          {getReleaseVersionText(releaseVersion)}
        </span>
      )}

      {labelIcon === 'primaryKey' && (
        <>
          <Icon size="xs" className="ml-2 mr-1" ryecon={RyeconKey} />
          <span>PK</span>
        </>
      )}
    </div>
  );
};
